module.exports = __webpack_public_path__ + "files/a73c94c899af83116279e5adaf9d2d5d.png";